import React, { forwardRef, useImperativeHandle, useMemo, useState } from "react";
import {
  Checkbox,
  Dropdown,
  PrimaryButton,
  Stack,
  Text,
  TextField,
} from "@fluentui/react";
import { t } from "i18next";
const GenerateClientCredentialsModal = forwardRef((props, ref) => {
  const [errors, setErrors] = useState({
    clientName: "",
    description: "",
    firms: "",
    scopes: "",
  });

  
  const validate = () => {
    const newErrors = {
      clientName: "",
      description: "",
      firms: "",
      scopes: "",
    };

    if (!props.clientName.trim()) {
      newErrors.clientName = t("client-credentials.validation.clientNameRequired");
    } else if (props.clientName.trim().length < 3) {
      newErrors.clientName = t("client-credentials.validation.clientNameMinLength")
    } else if (props.clientName.length > 30) {
      newErrors.clientName = t(
        "client-credentials.validation.clientNameMaxLength",
        { max: 30 }
    );
    }

    if (props.description.length > 150) {
      newErrors.description = t(
        "client-credentials.validation.descriptionMaxLength",
        { max: 150 }
    );
    }

    setErrors(newErrors);

    return Object.values(newErrors).every((v) => v === "");
  };

    useImperativeHandle(ref, () => ({
        validate
    }));
  const toTitleCase = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  // Can be used later
  // const SCOPES = Array.isArray(props.scopes)
  //   ? props.scopes.map((scope) => ({
  //       id: scope.id,
  //       key: scope.scopeValue,
  //       text: toTitleCase(scope.action) + " " + toTitleCase(scope.resource),
  //     }))
  //   : [];

  const firmOptions = useMemo(() => {
    return props?.firms.map((f) => ({
      key: f.value,
      text: f.label,
    }));
  }, [props?.firms]);

  // const handleScopeChange = (scope, checked) => {
  //   if (checked) {
  //     props?.setSelectedScopes((prev) => [...prev, scope.id]);
  //   } else {
  //     props?.setSelectedScopes((prev) => prev.filter((id) => id !== scope.id));
  //   }
  // };

  // const handleFirmChange = (_, option) => {
  //   if (!option) return;

  //   if (option.selected) {
  //     props?.setSelectedFirmIds((prev) => [...prev, option.key]);
  //   } else {
  //     props?.setSelectedFirmIds((prev) =>
  //       prev.filter((id) => id !== option.key),
  //     );
  //   }
  // };

  return (
    <Stack
      tokens={{ childrenGap: 18 }}
      styles={{
        root: {
          padding: "5px 10px",
        },
      }}
    >
    <Stack tokens={{ childrenGap: 2 }}>
      <TextField
        label={t("client-credentials.clientName")}
        required
        value={props?.clientName}
        maxLength={100}
        onChange={(_, value) => {
          props?.setClientName(value || "");
          if (errors.clientName) {
            setErrors((prev) => ({
              ...prev,
              clientName: "",
            }));
          }
        }}
      />
       {errors.clientName && (
          <Text
            styles={{
              root: {
                margin:"0px",
                color: "red",
                fontSize: "12px",
                fontWeight:"700"
              },
            }}
          >
            {errors.clientName}
          </Text>
        )}
        </Stack> 
        <Stack tokens={{ childrenGap: 2 }}>     
        <TextField
        label={t("client-credentials.description")}
        multiline
        rows={3}
        value={props?.description}
        maxLength={500}
        onChange={(_, value) => {
          props?.setDescription(value || "");
         if (errors.description) {

            setErrors(prev => ({
                ...prev,
                description: ""
            }));
          }
        }}
      />
       {errors.description && (
          <Text
            styles={{
              root: {
                color: "red",
                fontSize: "12px",
                fontWeight:"700"
              },
            }}
          >
            {errors.description}
          </Text>
        )}
        </Stack>
        {/* <Stack tokens={{ childrenGap: 2 }}>
      <Dropdown
        label={t("client-credentials.firmAccess")}
        placeholder="Select one or more firms"
        multiSelect
        selectedKeys={props?.selectedFirmIds}
        options={firmOptions}
        styles={{
            label: {
            color: "#ffffff",      
            fontWeight: 600,
        },
        }}
        onChange={(e, option) => {
          handleFirmChange(e, option);

          if (errors.firms) {
            setErrors((prev) => ({
              ...prev,
              firms: "",
            }));
          }
        }}
      />
       {errors.firms && (
          <Text
            styles={{
              root: {
                color: "red",
                fontSize: "12px",
                fontWeight:"700"
              },
            }}
          >
            {errors.firms}
          </Text>
        )}
        </Stack>


      <Stack tokens={{ childrenGap: 8 }}>
        <Text
          variant="medium"
          styles={{
            root: {
              fontWeight: 700,
            },
          }}
        >
         {t("client-credentials.scopes")}
        </Text>
        <Stack tokens={{ childrenGap: 2 }}>
        {SCOPES.map((scope) => (
          <Checkbox
            key={scope.key}
            label={scope.text}
            checked={props?.selectedScopes.includes(scope.id)}
            onChange={(_, checked) => {
              handleScopeChange(scope, checked);

              if (errors.scopes) {
                setErrors((prev) => ({
                  ...prev,
                  scopes: "",
                }));
              }
            }}
          />
        ))}
        {errors.scopes && (
          <Text
            styles={{
              root: {
                color: "red",
                fontSize: "12px",
                fontWeight:"700"
              },
            }}
          >
            {errors.scopes}
          </Text>
        )}
        </Stack>
      </Stack> */}

      <Stack
        horizontal
        horizontalAlign="end"
        tokens={{ childrenGap: 10 }}
      ></Stack>
    </Stack>
  );
});

export default GenerateClientCredentialsModal;
